import { handlePromise } from "../../../../utils/handlePromisse"
import { Patient, createPatient, savePatient } from "../../../../services/patient.service"

// ----------------------------------------------------------------------

/**
 * Constrói o payload (JSON ou FormData) e persiste o paciente via API.
 * Extraído de patients-page handleSavePatient — zero mudança de comportamento.
 *
 * @param patientData  Dados do formulário com `photos` (novos arquivos) e `removedImageIds`
 * @returns [undefined, Error | null] — null = sucesso
 */
export async function savePatientData(
    patientData: Patient & { photos?: File[]; removedImageIds?: number[] }
): Promise<[void | undefined, any]> {
    const isNewPatient = !patientData.id || patientData.id === 0
    const formatDate = (date: string | undefined) => {
        if (!date) return undefined
        return date.split('T')[0]
    }
    const basePayload: any = {
        name: patientData.name,
        phone: patientData.phone,
        consultationDate: formatDate(patientData.consultationDate),
        returnDate: formatDate(patientData.returnDate),
        observation: patientData.observation,
        anamnese: patientData.anamnese,
        events: Array.isArray(patientData.events)
            ? patientData.events.map(ev => {
                const evCopy = { ...ev }
                if ('id' in evCopy) delete evCopy.id
                if ('images' in evCopy) delete evCopy.images
                const formattedDate = formatDate(evCopy.date)
                if (formattedDate) evCopy.date = formattedDate
                return evCopy
            })
            : patientData.events,
        removedImageIds: patientData.removedImageIds,
        tags: Array.isArray(patientData.tags) ? patientData.tags : [],
    }
    let payloadToSend: any = basePayload
    const config = {}
    const hasPhotos = patientData.photos && Array.isArray(patientData.photos) && patientData.photos.length > 0
    const hasRemovedImages = Array.isArray(basePayload.removedImageIds) && basePayload.removedImageIds.length > 0
    if (hasPhotos || hasRemovedImages) {
        const formData = new FormData()
        if (basePayload && typeof basePayload === 'object') {
            Object.entries(basePayload).forEach(([key, value]) => {
                if (typeof value === 'object') {
                    formData.append(key, JSON.stringify(value))
                } else if (typeof value !== 'undefined') {
                    formData.append(key, String(value))
                }
            })
        }
        patientData.photos!.forEach((item: File | string) => {
            if (item instanceof File) {
                formData.append('images', item)
            } else if (typeof item === 'string') {
                formData.append('images', item)
            }
        })
        payloadToSend = formData
    }
    if (isNewPatient) {
        return handlePromise(createPatient(payloadToSend, config))
    } else {
        return handlePromise(savePatient(patientData.id, payloadToSend, config))
    }
}
